import { render } from "./ShippingServicePreselectionRuleEditor.vue?vue&type=template&id=677b506a"
import script from "./ShippingServicePreselectionRuleEditor.vue?vue&type=script&lang=js"
export * from "./ShippingServicePreselectionRuleEditor.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__